import React from 'react';
import Form from '../../common/form/Form';
import { SCOPES } from '../../../constants/scopes.constants';
import InstantFeeCard from './feeStructureForm/elements/InstantFeeCard';
import FeeChargeInstanceCard from './feeStructureForm/elements/FeeChargeInstanceCard';
import StandardDeliveryCard from './feeStructureForm/elements/StandardDeliveryCard';
import FeeStrategyCard from './feeStructureForm/elements/FeeStrategyCard';
import AdvancedFeeConfigCard from './feeStructureForm/elements/AdvancedFeeConfigCard';
import styles from './feeStructureForm/styles/feeStructureForm.module.scss';

function FeeStructureForm({
    values = {},
    enabled = {},
    rules = {},
    handlers = {},
    panels = {},
    onCancel,
    onSubmit,
    loading,
    disabledSave,
    confirmBeforeSubmit = false,
    submitText = 'Save',
    readOnly = false,
}) {
    return (
        <Form
            onSubmit={onSubmit}
            loading={loading}
            disabled={disabledSave}
            onCancel={onCancel}
            confirmBeforeSubmit={confirmBeforeSubmit}
            submitText={loading ? 'Saving...' : submitText}
            readOnly={readOnly}
            submitGuardScope={SCOPES.CONFIGURATIONS_MANAGE}
        >
            <div className={styles.formGrid}>
                <InstantFeeCard
                    value={values.fee}
                    enabled={enabled.instantFee}
                    onChange={handlers.setFee}
                    onToggleEnabled={() => handlers.toggleFeeSection('instantFee')}
                />
                <FeeChargeInstanceCard
                    value={values.feeInstance}
                    onChange={handlers.setFeeInstance}
                />
                <StandardDeliveryCard
                    time={values.standardFreeAdvanceTime}
                    unit={values.standardFreeAdvanceUnit}
                    onChangeTime={handlers.setStandardFreeAdvanceTime}
                    onChangeUnit={handlers.setStandardFreeAdvanceUnit}
                />
                <FeeStrategyCard
                    value={values.feeStrategy}
                    onChange={handlers.setFeeStrategy}
                />
                <div className={styles.fullSpan}>
                    <AdvancedFeeConfigCard
                        rules={rules}
                        handlers={handlers}
                        panels={panels}
                        enabled={enabled}
                    />
                </div>
            </div>
        </Form>
    );
}

export default FeeStructureForm;
